import { Loader2, Search, Terminal, WifiOff, AlertCircle } from "lucide-react";
import { Button, cn } from "@fox1ck-org/ui";

interface LogsEmptyStateProps {
  variant: "loading" | "empty" | "stream-waiting" | "disconnected" | "missing-pod" | "error";
  message?: string;
  reconnectAttempt?: number;
  onAction?: () => void;
  actionLabel?: string;
  className?: string;
}

const VARIANT_ICONS = {
  loading: Loader2,
  empty: Search,
  "stream-waiting": Terminal,
  disconnected: WifiOff,
  "missing-pod": AlertCircle,
  error: AlertCircle,
} as const;

const VARIANT_TITLES = {
  loading: "Загружаем журналы…",
  empty: "По этим фильтрам журналов нет",
  "stream-waiting": "Ждём вывод",
  disconnected: "Переподключаемся…",
  "missing-pod": "Под не найден",
  error: "Ошибка потока",
} as const;

export function LogsEmptyState({
  variant,
  message,
  reconnectAttempt,
  onAction,
  actionLabel,
  className,
}: LogsEmptyStateProps) {
  const Icon = VARIANT_ICONS[variant];
  const title = VARIANT_TITLES[variant];
  const isSpinning = variant === "loading" || variant === "disconnected";

  return (
    <div
      className={cn(
        "h-full flex flex-col items-center justify-center text-center px-6 py-12",
        className
      )}
    >
      <Icon
        className={cn(
          "h-8 w-8 mb-3 text-muted-foreground/60",
          isSpinning && "animate-spin",
          variant === "missing-pod" && "text-yellow-400/70",
          variant === "error" && "text-destructive/70"
        )}
      />
      <h3 className="text-sm font-medium text-foreground">{title}</h3>
      {variant === "disconnected" && reconnectAttempt ? (
        <p className="text-xs text-muted-foreground mt-1">
          attempt {reconnectAttempt}
        </p>
      ) : null}
      {message && (
        <p className="text-xs text-muted-foreground mt-1 max-w-sm">{message}</p>
      )}
      {variant === "empty" && !message && (
        <p className="text-xs text-muted-foreground mt-1">
          Расширьте период, снимите фильтры или включите режим онлайн.
        </p>
      )}
      {variant === "stream-waiting" && !message && (
        <p className="text-xs text-muted-foreground mt-1">
          Поток подключён, ждём первую строку от пода.
        </p>
      )}
      {onAction && actionLabel && (
        <Button variant="outline" size="sm" className="mt-4" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
